import {
	FavoritesService
} from 'sharebase/services/favoritesService';
import {
	IDocumentService
} from 'sharebase/services/documentService';
import {
	IFolderService
} from 'sharebase/services/folderService';
import {
	ShareBaseItem,
	ShareBaseDocument,
	ShareBaseFolder,
	pxItemTypeGuards as TypeGuards
} from 'phoenix/domain';
import {
	ToolbarService
} from '../services/appToolBarService';


export class FavoritesDataStore {
	public static $inject = [
		'$http',
		'$q',
		'sbSortContentFilter',
		'sbDocumentService',
		'sbFolderService',
		'sbFavoritesService',
		'sbaToolbarService'
	]

	public favoritedItems:ShareBaseItem[] = [];

	constructor(
		private readonly $http:ng.IHttpService,
		private readonly $q:ng.IQService,
		private readonly sortContent,
		private readonly sbDocumentService:IDocumentService,
		private readonly sbFolderService:IFolderService,
		private readonly sbFavoritesService:FavoritesService,
		private readonly sbaToolbarService:ToolbarService,
	) {
	}

	public load() {
		return this.sbFavoritesService
			.getFavorites()
			.then(favorites => {
				return this.$q.all<ShareBaseItem>(favorites.map(favorite => {
					let link;
					if (favorite.FolderId) {
						link = favorite.Links.FolderUri;
					}
					else if (favorite.DocumentId) {
						link = favorite.Links.DocumentUri;
					}

					return this.$http
						.get(link)
						.then(response => {
							let item = response.data as ShareBaseItem;
							item.IsFavorite = true;
							return item;
						});
				}));
			})
			.then(items => {
				this.favoritedItems = items;
				this.sort(this.sbaToolbarService.sortType);

				return items;
			});
	}

	public sort(sortType) {
		this.favoritedItems = this.sortContent(this.favoritedItems, sortType.type, sortType.ascending);
	}

	public addFavorite(item:ShareBaseItem){
		let p:ng.IPromise<any>;
		
		if(TypeGuards.isShareBaseDocument(item)){
			p = this.sbFavoritesService.setDocumentAsFavorite(item.DocumentId);
		}
		else if(TypeGuards.isShareBaseFolder(item)){
			p = this.sbFavoritesService.setFolderAsFavorite(item.FolderId);
		}
		else {
			p = this.$q.reject();
		}

		return p.then(() => {
			item.IsFavorite = true;
			this.favoritedItems.push(item);
		});
	}

	public removeFavorite(item:ShareBaseItem){
		let p:ng.IPromise<any>;
		
		if(TypeGuards.isShareBaseDocument(item)){
			p = this.sbFavoritesService
				.removeDocumentFromFavorites(item.DocumentId)
				.then(() => {
					this.favoritedItems = this.favoritedItems.filter(i => {
						return TypeGuards.isShareBaseDocument(i) ? i.DocumentId !== item.DocumentId : true;
					});
				});
		}
		else if(TypeGuards.isShareBaseFolder(item)){
			p = this.sbFavoritesService
				.removeFolderFromFavorites(item.FolderId)
				.then(() => {
					this.favoritedItems = this.favoritedItems.filter(i => {
						return TypeGuards.isShareBaseFolder(i) ? i.FolderId!== item.FolderId : true;
					});
				});
		}
		else {
			p = this.$q.reject();
		}

		return p.then(() => {
			item.IsFavorite = false;
		});
	}



	public renameDocument(document:ShareBaseDocument, newName:string) {
		return this.sbDocumentService.renameDocument(document, newName)
			.then((renamedDocument:ShareBaseDocument) => {
				this.favoritedItems = this.favoritedItems.map((favorite:ShareBaseDocument) => {
					if (favorite.DocumentId === renamedDocument.DocumentId) {
						favorite.DocumentName = renamedDocument.DocumentName;
					}
					return angular.copy(favorite);
				});
				return document
			});
	}

	public renameFolder(folder:ShareBaseFolder, newName:string) {
		return this.sbFolderService.renameFolder(folder, newName)
			.then((renamedFolder:ShareBaseFolder) => {
				this.favoritedItems = this.favoritedItems.map((favorite:ShareBaseFolder) => {
					if (favorite.FolderId === renamedFolder.FolderId) {
						favorite.FolderName = renamedFolder.FolderName;
					}
					return angular.copy(favorite);
				});
				return folder;
			});
	}

	public deleteFolder(folder:ShareBaseFolder, purge:boolean = false) {
		return this.sbFolderService
			.deleteFolder(folder, purge)
			.then(res => {
				this.favoritedItems = this.favoritedItems.filter((folder:ShareBaseFolder) => {
					return folder.FolderId !== folder.FolderId;
				});
				return res;
			});
	}

	public deleteDocument(document:ShareBaseDocument, purge:boolean = false) {
		return this.sbDocumentService
			.deleteDocument(document, purge)
			.then(res => {
				this.favoritedItems = this.favoritedItems.filter((document:ShareBaseDocument) => {
					return document.DocumentId !== document.DocumentId;
				});
				return res;
			});
	}

	public clearStore(){
		this.favoritedItems = [];
	}
}


// WEBPACK FOOTER //
// ./src/sharebase-app/dataStores/favoritesDataStore.ts